var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('PageBar',[_vm._v("\n        23234\n    ")]),_vm._v(" "),_c('Container',[_vm._v("\n        test\n    ")]),_vm._v(" "),_c('PageBar',[_vm._v("\n        23234\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }